// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-79f577d0] .phoneText {\n  color: #898989 !important;\n}\n[data-v-79f577d0] .van-field__label {\n  color: #0d0d0d;\n}\n[data-v-79f577d0] .van-field {\n  padding: 4vw 2.66667vw;\n}\n[data-v-79f577d0] .van-field__label {\n  width: auto;\n}\n.tips[data-v-79f577d0] {\n  color: #898989;\n  font-size: 12px;\n  margin: 5.33333vw 4.26667vw;\n  text-align: center;\n}", ""]);
// Exports
module.exports = exports;
